import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <span>Project music releases made by:</span>
            <span> Emma Lindell & Ida Näslund</span>
            <span>On Technigo Bootcamp spring 2022</span>
        </footer>
    )
}

export default Footer